export default {
  methods: {
    qualityGeneralValueByInspectGUI: function (quality_inspect, quality_template_gui) {
      return this.qualityGeneralByInspectGUI(quality_inspect, quality_template_gui)
      ?.value;
    },
    qualityGeneralByInspectGUI: function (quality_inspect, quality_template_gui) {
      return quality_inspect.quality_generals.find(
        (quality_general) =>
          quality_general.quality_attribute_id === quality_template_gui.quality_attribute.id
      );
    }
  }
}